/**
 * @typedef {import('BMapsSrc/model').Compound} Compound
 */
import { ensureArray } from 'BMapsSrc/util/js_utils';
import * as targetActions from '.';
import store from '../store';

export function addStructureToProjectTargets(mapCase, targetInfo={}) {
    store.dispatch(targetActions.addStructure(getTargetInfoForMapCase(mapCase, targetInfo)));
}

export function removeStructureByMapCase(mapCase) {
    if (mapCase) {
        store.dispatch(targetActions.removeStructure({ mapCase }));
        return;
    }
    console.log('Error: No mapCase provided to Redux');
}

export function removeAllStructures() {
    store.dispatch(targetActions.removeAllStructures());
}

// use setProteinTarget in connectedDataCmds to also rebuild the protein tree
/**
 * @param {import('BMapsSrc/model').MapCase} mapCase
 * @param {{isTarget?: boolean}} targetInfo
 */
export function setProteinTarget(mapCase, targetInfo) {
    store.dispatch(targetActions.setProteinTarget(getTargetInfoForMapCase(mapCase, targetInfo)));
}

/**
 * @typedef {{ isTarget: boolean }} targetInfo
 * @typedef {{ mapCase: MapCase, targetInfo: { isTarget: boolean } }} mapCaseInfo
 * @param {mapCaseInfo[] | mapCaseInfo} mapCaseInfoList
 */
export function setAllTargetInfo(mapCaseInfoList) {
    const newTargetInfo = ensureArray(mapCaseInfoList);
    store.dispatch(targetActions.setAllTargetInfo(newTargetInfo));
}
export function getTargetInfoMap() {
    const map = new Map();
    const list = store.getState().projectState.targetList;
    list.forEach((structure) => {
        map.set(structure.mapCase, structure);
    });
    return (map);
}

function getTargetInfoForMapCase(mapCase, targetInfo={}) {
    const targetInfoToAdd = {
        isTarget: targetInfo.isTarget ?? true,
        // other props would be added here, with defaults
    };
    return {
        mapCase,
        displayName: mapCase.displayName,
        ...targetInfoToAdd,
    };
}

export function setCompoundTableState(compoundTableState) {
    store.dispatch(targetActions.setCompoundTableState(compoundTableState));
}

export function setScoringTableState(scoringTableState) {
    store.dispatch(targetActions.setScoringTableState(scoringTableState));
}

export function setJobsCompoundsTableState(jobsCompoundsTableState) {
    store.dispatch(targetActions.setJobsCompoundsTableState(jobsCompoundsTableState));
}

export function setJobsGridTableState(jobsGridTableState) {
    store.dispatch(targetActions.setJobsGridTableState(jobsGridTableState));
}

export function setScreeningTableState(screeningTableState) {
    store.dispatch(targetActions.setScreeningTableState(screeningTableState));
}
export function setSidePanelWidth(sidePanelWidth, table) {
    store.dispatch(targetActions.setSidePanelWidth({ table, sidePanelWidth }));
}

export function getTableState() {
    return { ...store.getState().projectState.tableState };
}

export function setTableState(tableState) {
    store.dispatch(targetActions.setTableState(tableState));
}

export function setCoralMapState(coralMap, table) {
    store.dispatch(targetActions.setCoralMapState({ coralMap, table }));
}

export function updateScreeningPropertySettings(settings) {
    store.dispatch(targetActions.updateScreeningPropertySettings(settings));
}

export function setActiveChart(chart, table) {
    store.dispatch(targetActions.setActiveChart({ chart, table }));
}

export function setTargetsTableState(targetsTableState) {
    store.dispatch(targetActions.setTargetsTableState(targetsTableState));
}
